import { Grid, Paper, Typography } from '@mui/material';
import {
  LockerUtilisationChartHeader,
  LockerUtilisationChartHeaderProps
} from '../../locker-utilisation/locker-utilisation-chart-header/locker-utilisation-chart-header.components';
import {
  DeliveryContainerCapacityChart,
  DeliveryContainerCapacityChartProps
} from '../delivery-container-capacity-chart/delivery-container-capacity-chart.component';
import {
  DeliveryContainerUtilisationChart,
  DeliveryContainerUtilisationChartProps
} from '../delivery-container-utilisation-chart/delivery-container-utilisation-chart.component';
import { useDeliveryContainerUtilisationCardStyles } from './delivery-container-utilisation-card.styles';

export interface DeliveryContainerUtilisationCardProps {
  HeaderProps: LockerUtilisationChartHeaderProps;
  UtilisationProps: DeliveryContainerUtilisationChartProps;
  CapacityProps: DeliveryContainerCapacityChartProps;
  utilisationError?: boolean;
  capacityError?: boolean;
}

export function DeliveryContainerUtilisationCard({
  HeaderProps,
  UtilisationProps,
  CapacityProps,
  utilisationError,
  capacityError
}: DeliveryContainerUtilisationCardProps) {
  const classes = useDeliveryContainerUtilisationCardStyles();
  return (
    <Paper className={classes.card}>
      <Grid container>
        <Grid container style={{ marginBottom: '16px' }}>
          <LockerUtilisationChartHeader {...HeaderProps} />
        </Grid>
        <div className={classes.divider} />
        <Grid container>
          <Typography component="h2" className={classes.sectionTitle}>
            Capacity
          </Typography>
          {capacityError ? (
            <div className={classes.errorMessage}>Failed to load capacity data.</div>
          ) : (
            <DeliveryContainerCapacityChart {...CapacityProps} />
          )}
        </Grid>
        <Grid container className={classes.sectionSpacer}>
          <Typography component="h2" className={classes.sectionTitle}>
            Utilisation
          </Typography>
          {utilisationError ? (
            <div className={classes.errorMessage}>Failed to load utilisation data.</div>
          ) : (
            <DeliveryContainerUtilisationChart {...UtilisationProps} />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}
